/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type ModalMajStoreType = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

const useModalMajStore = create<ModalMajStoreType>()(
  devtools((set) => ({
    open: false,
    setOpen: (open) => set({ open }),
  })),
);

export default useModalMajStore;
